export default "__VITE_ASSET__867df2de__"